import ContactDetailsList from './components/ContactDetailsList';
import Vue from 'vue';

export default function(entityType, entityId) {
  new Vue({
    el: '.contact-details-list',
    render: h => h(ContactDetailsList, {props: {
      entityType,
      entityId,
    }}),
  });
};



// WEBPACK FOOTER //
// ./assets/js/contact-details.js